import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import IncidenceMessage from 'modules/bookkeepers/store/models/IncidenceMessage'

class IncidenceMessages extends Collection<IncidenceMessage> {
  get cacheKey(): string {
    return 'incidenceMessages'
  }

  model() {
    return IncidenceMessage
  }
}

const singleton: IncidenceMessages = new IncidenceMessages()

const { provider: IncidenceMessagesProvider, hook: useIncidenceMessages } = createCollectionContext<
  IncidenceMessage,
  IncidenceMessages
>()

export { IncidenceMessagesProvider, useIncidenceMessages }

export default singleton
